/* eslint-disable jsx-a11y/anchor-is-valid */

import { useState, useEffect, useCallback, useRef } from 'react'

import { useFormik } from 'formik'

import * as Yup from 'yup'

import clsx from 'clsx'

import { Link, useLocation, useNavigate } from 'react-router-dom'

import { toAbsoluteUrl } from 'src/marketConnect/helpers'

import { PasswordMeterComponent } from 'src/marketConnect/assets/ts/components'

import { useAuth } from '../core/Auth'

import { useAppDispatch, useAppSelector } from 'src/redux/storeHooks'

import { fetchUserAccountDetailsAsync } from 'src/redux/actions/accountActions'
import { fetchPlatformsAsync } from 'src/redux/actions/platformActions'

import { handleOauthForConnectPlatformAsync, loginAsync, registrationAsync } from 'src/redux/actions/authActions'

import useAppToast from 'src/hooks/useAppToast'

import { setLoggingData } from 'src/redux/slices/authSlice'

import {

  accessSessionTokenKeyName,

  refreshSessionTokenKeyName,

  tiktokPlatformData,

  walmartPlatformData,

} from 'src/utils/constants'

import { finalizeTikTokAfterAuth } from 'src/utils/finalizeTikTokAfterAuth'

import {
  captureWalmartMarketplaceHandoffFromSearch,
  getWalmartPlatformIdFromPayload,
  getUserIdFromAuthPayload,
  redirectToWalmartMarketplaceAuthIfNeeded,
} from 'src/utils/walmartMarketplaceHandoff'

import ReCAPTCHA from "react-google-recaptcha";

import { TwakScript } from 'src/externalScript/TwakScript'

import { Button } from 'react-bootstrap'

import GoogleLoginButton from './GoogleLoginButton'

import TermsAndPrivacyConsent, { AgreementModal } from './TermsAndPrivacyConsent'
import { createPortal } from 'react-dom'

const initialValues = {

  name: '',

  email: '',

  password: '',

  changepassword: '',

  acceptTerms: true,

}



const registrationSchema = Yup.object().shape({

  name: Yup.string()

    .min(3, 'Minimum 3 symbols')

    .max(50, 'Maximum 50 symbols')

    .required('Full name is required'),

  email: Yup.string()

    .email('Wrong email format')

    .min(3, 'Minimum 3 symbols')

    .max(50, 'Maximum 50 symbols')

    .required('Email is required'),



  password: Yup.string()

    .matches(

      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{8,}$/,

      'Use 8 or more characters with at least one uppercase letter, one lowercase letter, one special character, and one number'

    )

    .max(50, 'Maximum 50 symbols')

    .required('Password is required'),

  changepassword: Yup.string()

    .matches(

      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{8,}$/,

      'Use 8 or more characters with at least one uppercase letter, one lowercase letter, one special character, and one number'

    )

    .max(50, 'Maximum 50 symbols')

    .required('Password confirmation is required')

    .oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),

  acceptTerms: Yup.bool().required('You must accept the terms and conditions'),

})



export function Registration() {

  const [loading, setLoading] = useState(false)

  const [captchaToken, setCaptchaToken] = useState<string | null>(null)
  const captchaRef = useRef<ReCAPTCHA | null>(null)
  const captchaTokenRef = useRef<string | null>(null)

  const { saveAuth, setCurrentUser } = useAuth()

  const { successToast, errorToast } = useAppToast()

  const dispatch = useAppDispatch()

  const navigate = useNavigate()

  const { } = useAppSelector((state) => state)

  const { search } = useLocation(); // Hook to access the URL query parameters

  const queryParams = new URLSearchParams(search);

  useEffect(() => {
    const handoffStatus = captureWalmartMarketplaceHandoffFromSearch(search)
    if (handoffStatus === 'invalid') {
      errorToast('Walmart authorization URL is missing or invalid.')
    }
  }, [errorToast, search])


  const source = queryParams.get('SOURCE') || queryParams.get('source') || ''

  const normalizedSource = source.toUpperCase()

  const isRestrictedOnboardingFlow = normalizedSource === 'TIKTOK' || normalizedSource === 'WALMART'

  const platformStorageKey = normalizedSource === 'WALMART' ? walmartPlatformData : tiktokPlatformData

  const cachedTikTokPayloadRaw = localStorage.getItem(platformStorageKey)

  let cachedTikTokPayload: any = null

  try {

    cachedTikTokPayload = cachedTikTokPayloadRaw ? JSON.parse(cachedTikTokPayloadRaw) : null

  } catch (error) {

  }

  const persistTikTokProfileChanges = useCallback(

    (overrides: { name?: string; email?: string }) => {

      try {

        const payloadRaw = localStorage.getItem(platformStorageKey)

        if (!payloadRaw) {

          return

        }

        const parsedPayload = JSON.parse(payloadRaw || '{}')

        const nextPayload = { ...parsedPayload }

        if (Object.prototype.hasOwnProperty.call(overrides, 'name')) {

          nextPayload.name = overrides.name

        }

        if (Object.prototype.hasOwnProperty.call(overrides, 'email')) {

          nextPayload.email = overrides.email

        }

        localStorage.setItem(platformStorageKey, JSON.stringify(nextPayload))

      } catch (error) {

      }

    },

    [platformStorageKey]

  )



  const userEmailFromURL = normalizedSource === 'SHIPPHQ' ? queryParams.get('user_email') || '' : ''

  const applicationIdFromURL =
    normalizedSource === 'SHIPPHQ' ? queryParams.get('application_id') || '' : ''

  const addStaffUserFromURL =
    normalizedSource === 'SHIPPHQ' ? queryParams.get('add_staff_user') || '' : ''

  const nameFromURL =

    queryParams.get('name') ||

    cachedTikTokPayload?.name ||

    cachedTikTokPayload?.username ||

    ''

  const emailFromURL =

    userEmailFromURL ||

    queryParams.get('email') ||

    cachedTikTokPayload?.email ||

    ''

  const shouldLockEmailField = Boolean(userEmailFromURL)

  const invitedByFromURL = queryParams.get('invited_by');

  // Hide Google sign up only for known restricted onboarding flows. Default: show for new/unknown sources.
  const shouldShowGoogleSignup = !isRestrictedOnboardingFlow
  const [termsAgreed, setTermsAgreed] = useState(false)
  const [showGoogleTcModal, setShowGoogleTcModal] = useState(false)

  // Conditionally set the initialValues object based on the presence of URL query parameters

  const initialValues = {

    name: nameFromURL || '',

    email: shouldLockEmailField ? emailFromURL : '', // SHIPPHQ passes a verified user_email that should not be edited.

    password: '',

    changepassword: '',

    acceptTerms: true,

    invited_by: invitedByFromURL || ''

  };



  const registrationSchema = Yup.object().shape({

    name: Yup.string()

      .min(3, 'Minimum 3 symbols')

      .max(50, 'Maximum 50 symbols')

      .required('Full name is required'),

    email: Yup.string()

      .email('Wrong email format')

      .min(3, 'Minimum 3 symbols')

      .max(50, 'Maximum 50 symbols')

      .required('Email is required'),

    password: Yup.string()

      .matches(

        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[a-zA-Z\d!@#$%^&*(),.?":{}|<>]{8,}$/,

        'Use 8 or more characters with at least one uppercase letter, one lowercase letter, one special character, and one number'

      )

      .max(50, 'Maximum 50 symbols')

      .required('Password is required'),

    changepassword: Yup.string()

      .oneOf([Yup.ref('password')], "Password and Confirm Password didn't match")

      .required('Password confirmation is required'),

    acceptTerms: Yup.bool().required('You must accept the terms and conditions'),

  })

  const getRegistrationErrorDetails = (response: any) => {
    const payload = response?.payload
    const status =
      payload?.status ??
      payload?.data?.status_code ??
      payload?.status_code
    const message =
      payload?.data?.message ??
      payload?.data?.massage ??
      payload?.message ??
      payload?.massage

    return { status, message }
  }

  const resetCaptcha = () => {
    captchaRef.current?.reset()
    captchaTokenRef.current = null
    setCaptchaToken(null)
  }



  const formik = useFormik({

    initialValues,

    validationSchema: registrationSchema,

    onSubmit: async (values, { setStatus, setSubmitting }) => {

      const currentCaptchaToken = captchaTokenRef.current
      if (!currentCaptchaToken) {
        errorToast('Please complete captcha verification.')
        return
      }
      setLoading(true)

      try {

        persistTikTokProfileChanges({

          name: values?.name,

          email: values?.email,

        })

        if (invitedByFromURL) {

          const response = await dispatch(

            registrationAsync({

              name: nameFromURL,

              email: emailFromURL,

              password: values.password,

              user_type: 'USER',

              is_superuser: false,

              is_staff: false,

              is_active: true,

              invited_by: Number(invitedByFromURL),

              source: source ? source : null,
              application_id: applicationIdFromURL || null,
              add_staff_user: addStaffUserFromURL || null,
              'g-recaptcha-response': currentCaptchaToken || undefined,

            })

          )

          if (response?.payload?.status_code === 201) {

            successToast(response.payload.massage)

            setLoading(false)

            setTimeout(() => {

              dispatch(

                loginAsync({

                  email: values.email,

                  password: values.password,

                })

              ).then(async (loginResponse) => {

                if (loginResponse.payload?.access) {

                  localStorage.setItem(accessSessionTokenKeyName, loginResponse?.payload?.access)

                  localStorage.setItem(refreshSessionTokenKeyName, loginResponse?.payload?.refresh)

                  let walmartOauthUserId = getUserIdFromAuthPayload(loginResponse?.payload)
                  if (!walmartOauthUserId) {
                    const userResponse = await dispatch(fetchUserAccountDetailsAsync())
                    walmartOauthUserId = getUserIdFromAuthPayload(userResponse?.payload)
                  }
                  const walmartPlatformResponse = await dispatch(fetchPlatformsAsync({ search: 'WALMART' }))
                  const walmartPlatformId = getWalmartPlatformIdFromPayload(walmartPlatformResponse?.payload)
                  if (await redirectToWalmartMarketplaceAuthIfNeeded((params) =>
                    dispatch(handleOauthForConnectPlatformAsync(params)),
                    { user_id: walmartOauthUserId, platform_id: walmartPlatformId }
                  )) {
                    return
                  }
                  dispatch(
                    setLoggingData({
                      isLoggedIn: true,
                      userData: loginResponse.payload.data,
                      status: loginResponse.payload.status,
                    })
                  )
                  await finalizeTikTokAfterAuth(dispatch)
                  navigate('/')
                } else {

                  errorToast('Login failed')
                  resetCaptcha()

                }

              })

            }, 1500)

          } else {

            const { status, message } = getRegistrationErrorDetails(response)

            if (status === 429) {
              errorToast(message || 'Too many signup attempts. Please try again later.')
            } else if (status === 400) {
              errorToast(message || 'Registration request is invalid.')
            } else {
              errorToast(message || 'Registration failed. Please try again.')
            }

            setLoading(false)
            resetCaptcha()

          }



        } else {

          const response = await dispatch(

            registrationAsync({

              name: values.name,

              email: values.email,

              password: values.password,

              user_type: 'USER',

              is_superuser: false,

              is_staff: false,

              is_active: true,

              invited_by: null,

              source: source ? source : null,
              application_id: applicationIdFromURL || null,
              add_staff_user: addStaffUserFromURL || null,
              'g-recaptcha-response': currentCaptchaToken || undefined,

              // parent: invitedByFromURL ? Number(invitedByFromURL) : null,

            })

          )

          if (response?.payload?.status_code === 201) {

            successToast(response.payload.massage)

            setLoading(false)

            setTimeout(() => {

              dispatch(

                loginAsync({

                  email: values.email,

                  password: values.password,

                })

              ).then(async (loginResponse) => {

                if (loginResponse.payload?.access) {

                  localStorage.setItem(accessSessionTokenKeyName, loginResponse?.payload?.access)

                  localStorage.setItem(refreshSessionTokenKeyName, loginResponse?.payload?.refresh)

                  let walmartOauthUserId = getUserIdFromAuthPayload(loginResponse?.payload)
                  if (!walmartOauthUserId) {
                    const userResponse = await dispatch(fetchUserAccountDetailsAsync())
                    walmartOauthUserId = getUserIdFromAuthPayload(userResponse?.payload)
                  }
                  const walmartPlatformResponse = await dispatch(fetchPlatformsAsync({ search: 'WALMART' }))
                  const walmartPlatformId = getWalmartPlatformIdFromPayload(walmartPlatformResponse?.payload)
                  if (await redirectToWalmartMarketplaceAuthIfNeeded((params) =>
                    dispatch(handleOauthForConnectPlatformAsync(params)),
                    { user_id: walmartOauthUserId, platform_id: walmartPlatformId }
                  )) {
                    return
                  }
                  dispatch(
                    setLoggingData({
                      isLoggedIn: true,
                      userData: loginResponse.payload.data,
                      status: loginResponse.payload.status,
                    })
                  )
                  await finalizeTikTokAfterAuth(dispatch)
                  const isWooCommerce = normalizedSource === 'WOOCOMMERCE'

                  if (isWooCommerce) {

                    navigate('/pricing')

                  } else {

                    navigate('/')

                  }

                } else {

                  errorToast('Login failed')
                  resetCaptcha()

                }

              })

            }, 1500)

          } else {

            const { status, message } = getRegistrationErrorDetails(response)

            if (status === 429) {
              errorToast(message || 'Too many signup attempts. Please try again later.')
            } else if (status === 400) {
              errorToast(message || 'Registration request is invalid.')
            } else {
              errorToast(message || 'Registration failed. Please try again.')
            }

            setLoading(false)
            resetCaptcha()

          }

        }



      } catch (error) {

        setLoading(false)
        resetCaptcha()

      }

    },

  })



  useEffect(() => {

    persistTikTokProfileChanges({

      name: formik.values?.name,

      email: formik.values?.email,

    })

  }, [formik.values.name, formik.values.email, persistTikTokProfileChanges])



  useEffect(() => {

    // Check if the script is already added

    const scriptId = "mouseflow-script";

    if (process.env['REACT_APP_ENV'] === 'production') {

      if (!document.getElementById(scriptId)) {

        const script = document.createElement("script");

        script.type = "text/javascript";

        script.defer = true;

        script.src = "//cdn.mouseflow.com/projects/d9c4c389-87cf-4a12-a4f1-2358807273b2.js";

        script.id = scriptId;

        document.head.appendChild(script);



        // Initialize the Mouseflow queue if not already set

        (window as any)._mfq = (window as any)._mfq || [];

      }

    }

    // Cleanup function to remove the script when the component unmounts

    return () => {

      const existingScript = document.getElementById(scriptId);

      if (existingScript) {

        existingScript.remove();

      }

      // Optionally clear the Mouseflow queue

      (window as any)._mfq = undefined;

    };

  }, []); // Empty dependency array ensures it runs only once when the component mounts



  useEffect(() => {

    PasswordMeterComponent.bootstrap()

  }, [])





  return (
    <>
      {isRestrictedOnboardingFlow && normalizedSource !== 'WALMART' && (
        <div
          className='rounded px-4 py-4 mb-4 border d-flex flex-column flex-md-row align-items-md-center gap-3'
          style={{ backgroundColor: '#f3fff6', borderColor: '#21bf57' }}
        >
          <div className='text-dark'>
            <div className='fw-semibold mb-1'>
              TikTok account has been connected successfully.
            </div>

            <div className='text-muted'>
              Register to proceed further. Login If already have an account.
            </div>
          </div>

          <Link
            to={`/auth/login${search || `?source=${normalizedSource}`}`}
            className='text-decoration-none ms-md-auto'
          >
            <button
              type='button'
              className='btn btn-sm fw-bold text-dark'
              style={{ backgroundColor: '#ffd54f' }}
            >
              Login
            </button>
          </Link>
        </div>
      )}

      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_signup_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-7'>
          {/* begin::Title */}

          <h2 className='text-dark fw-bolder'>Sign Up</h2>

          {/* end::Title */}

          {/* <div className='text-gray-500 fw-semibold fs-6'>Your Social Campaigns</div> */}
        </div>

        {shouldShowGoogleSignup && (
          <div className='text-center mb-3'>
            <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
              <GoogleLoginButton />
              {!termsAgreed && (
                <div 
                  style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10, cursor: 'pointer' }}
                  onClick={() => setShowGoogleTcModal(true)}
                />
              )}
            </div>

            <div className='d-flex align-items-center mt-4 mb-2'>
              <div className='flex-grow-1 border-bottom'></div>

              <span className='mx-2 text-muted fw-bold'>Or</span>

              <div className='flex-grow-1 border-bottom'></div>
            </div>
          </div>
        )}

        {/* begin::Heading */}

        {/* end::Heading */}

        {/* begin::Login options */}

        {shouldShowGoogleSignup && (
          <div className='row g-3'>
            <div className='col-md-6'>{/* placeholder for socials */}</div>
          </div>
        )}

        {/* end::Login options */}

        {/* <div className='separator separator-content my-14'>

        <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>

      </div>



      {formik.status && (

        <div className='mb-lg-15 alert alert-danger'>

          <div className='alert-text font-weight-bold'>{formik.status}</div>

        </div>

      )} */}

        {/* begin::Form group Firstname */}

        <div className='fv-row mb-4'>
          <label className='form-label fw-bolder text-dark fs-6'>User Full Name</label>

          <input
            placeholder='Full name'
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('name')}
            className={clsx(
              'form-control bg-transparent',

              { 'is-invalid': formik.touched.name && formik.errors.name },

              { 'is-valid': formik.touched.name && !formik.errors.name }
            )}
          />

          {formik.touched.name && formik.errors.name && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{String(formik.errors.name)}</span>
              </div>
            </div>
          )}
        </div>

        {/* end::Form group */}

        {/* begin::Form group Email */}

        <div className='fv-row mb-4'>
          <label className='form-label fw-bolder text-dark fs-6'>Email</label>

          <input
            placeholder='Email'
            type='email'
            autoComplete='off'
            readOnly={shouldLockEmailField}
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control bg-transparent',

              { 'is-invalid': formik.touched.email && formik.errors.email },

              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
          />

          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{String(formik.errors.email)}</span>
              </div>
            </div>
          )}
        </div>

        {/* end::Form group */}

        {/* begin::Form group Password */}

        <div className='fv-row mb-4' data-kt-password-meter='true'>
          <div className='mb-1'>
            <label className='form-label fw-bolder text-dark fs-6'>Password</label>

            <div className='position-relative mb-3'>
              <input
                type='password'
                placeholder='Password'
                autoComplete='off'
                {...formik.getFieldProps('password')}
                className={clsx(
                  'form-control bg-transparent',

                  {
                    'is-invalid': formik.touched.password && formik.errors.password,
                  },

                  {
                    'is-valid': formik.touched.password && !formik.errors.password,
                  }
                )}
              />

              {formik.touched.password && formik.errors.password && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.password}</span>
                  </div>
                </div>
              )}
            </div>

            {/* begin::Meter */}

            <div
              className='d-flex align-items-center mb-3'
              data-kt-password-meter-control='highlight'
            >
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>

              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>

              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>

              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
            </div>

            {/* end::Meter */}
          </div>

          <div className='text-muted'>
            Use 8 or more characters with a mix of letters, numbers & symbols.
          </div>
        </div>

        {/* end::Form group */}

        {/* begin::Form group Confirm password */}

        <div className='fv-row mb-4'>
          <label className='form-label fw-bolder text-dark fs-6'>Confirm Password</label>

          <input
            type='password'
            placeholder='Password confirmation'
            autoComplete='off'
            {...formik.getFieldProps('changepassword')}
            className={clsx(
              'form-control bg-transparent',

              {
                'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
              },

              {
                'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
              }
            )}
          />

          {formik.touched.changepassword && formik.errors.changepassword && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.changepassword}</span>
              </div>
            </div>
          )}
        </div>


        {/* end::Form group */}

        <div className='captcha-box my-2 overflow-hidden'>
          <ReCAPTCHA
            // ref={(r) => this.recaptcha = r}
            ref={captchaRef}
            sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY!}
            onChange={(val) => {
              captchaTokenRef.current = val
              setCaptchaToken(val)
            }}
          />
        </div>
        <TermsAndPrivacyConsent
          checked={termsAgreed}
          onChange={(val) => setTermsAgreed(val)}
        />

        {/* begin::Form group */}

        {/* <div className='fv-row mb-8'>

        <label className='form-check form-check-inline' htmlFor='kt_login_toc_agree'>

          <input

            className='form-check-input'

            type='checkbox'

            id='kt_login_toc_agree'

            {...formik.getFieldProps('acceptTerms')}

          />

          <span>

            I Accept the{' '}

            <a

              href='https://constacloud.com/tou.html'

              target='_blank'

              className='ms-1 link-primary'

            >

              Terms

            </a>

            .

          </span>

        </label>

        {formik.touched.acceptTerms && formik.errors.acceptTerms && (

          <div className='fv-plugins-message-container'>

            <div className='fv-help-block'>

              <span role='alert'>{formik.errors.acceptTerms}</span>

            </div>

          </div>

        )}

      </div> */}

        {/* end::Form group */}

        {/* begin::Form group */}

        <div className='text-center'>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-sm btn-primary w-100 mb-3 mt-2'
            disabled={formik.isSubmitting || !formik.isValid || !captchaToken || !termsAgreed}
          >
            {!loading && <span className='indicator-label'>Create Account</span>}

            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>

          <Link to={`/auth/login${search || ''}`}>
            <button
              type='button'
              id='kt_login_signup_form_cancel_button'
              className='btn btn-sm btn-light-primary w-100 mb-2'
            >
              Cancel
            </button>
          </Link>
        </div>

        {/* end::Form group */}
      </form>

      {showGoogleTcModal && createPortal(
        <AgreementModal
          isAlreadyAgreed={termsAgreed}
          isGoogleFlow={true}
          onClose={() => setShowGoogleTcModal(false)}
          onAgree={() => {
            setTermsAgreed(true)
            setShowGoogleTcModal(false)
            setTimeout(() => {
              const googleBtn = document.querySelector('.google-button-wrapper div[role="button"]') as HTMLElement;
              if (googleBtn) {
                googleBtn.click();
              } else {
                const iframeBtn = document.querySelector('.google-button-wrapper iframe') as HTMLElement;
                if (iframeBtn) iframeBtn.click();
              }
            }, 100);
          }}
        />,
        document.body
      )}

      <TwakScript />
    </>
  )

}
